import React from "react";

import clsx from "clsx";

interface Props {
  value: string;
  className?: string;
}

export const MetricsSection = ({ value, className }: Props) => (
  <div
    className={clsx(
      "font-mono metric-content overflow-hidden flex flex-col",
      className,
    )}
  >
    <div className="text-right">{value}</div>
  </div>
);
